import { CopyViewModalProvider } from '@monorepo/logs/src/contexts/CopyViewModalContext';
import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { Main } from '@monorepo/shared/componentsV2/Main';
import { useOpenClose } from '@monorepo/shared/hooks/useOpenClose';
import {
  fillHeightAndScrollable,
  verticalLayout,
} from '@monorepo/shared/styles/layout';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { EditViewInfoModalProvider } from '../../../contexts/EditViewInfoModalContext';
import { useLogsAndViewsPageContext } from '../../../contexts/LogsAndViewsPageContext';
import { useViews } from '../../../hooks/useViews';
import { ViewsToolbar } from '../ViewsToolbar';
import { CreateNewViewModal } from './CreateNewViewModal';
import { ViewsTable } from './ViewsTable';

const StyledMainContainer = styled(Main)`
  ${fillHeightAndScrollable}
  ${verticalLayout}
`;

const StyledViewsTable = styled(ViewsTable)`
  ${fillHeightAndScrollable}
`;

export function ViewsPageContent() {
  const { organizationId, projectId } = useParams();
  const [
    createNewViewModalIsOpen,
    openCreateNewViewModal,
    closeCreateNewViewModal,
  ] = useOpenClose();
  const { setIsSearchVisible, searchFilter } = useLogsAndViewsPageContext();

  const { isLoading, views } = useViews({
    organizationId,
    projectId,
  });

  const hasViewsOnPage = !!(views && views.length > 0);
  setIsSearchVisible(hasViewsOnPage);

  return (
    <ErrorBoundary>
      {createNewViewModalIsOpen && (
        <CreateNewViewModal
          closeModal={closeCreateNewViewModal}
          isOpen={createNewViewModalIsOpen}
        />
      )}
      <EditViewInfoModalProvider>
        <CopyViewModalProvider>
          <StyledMainContainer>
            <ViewsToolbar
              onCreateNewView={openCreateNewViewModal}
              isLoading={isLoading}
            />
            <StyledViewsTable
              filter={searchFilter}
              views={views}
              isLoading={isLoading}
            />
          </StyledMainContainer>
        </CopyViewModalProvider>
      </EditViewInfoModalProvider>
    </ErrorBoundary>
  );
}
